

  
const content = `# SecureAI Data Query
  
As a SecureAI user, you can ask any types of questions with your data sources. The data sources that you have access to are listed under the \`Data sources\` section above the 
user prompt window. You have to select at least one data source before you ask a question about your data. And you have the option to select multiple data sources if you 
anticipate your questions are related to more than one data source.  
  
SecureAI will leverage the GenAI Large Language Model (LLM) configured by your system administrator to handle all of your questions. The GenAI LLM will interpret your questions, 
interact with the data sources you have selected, and answer your questions with your data. Please note that SecureAI automatically enforces the data security policy configured 
for each GenAI LLM. If sensitive data should not be revealed to a GenAI LLM, SecureAI will used a proprietary solution to interact with GenAI LLM, so that GenAI LLM can perform 
data analysis without accessing the actual sensitive data.  
  
When SecureAI provides a response to your question, the sensitive, confidential, or regulated data may be masked, depending on whether you have access to such data or not. The 
data access roles assigned to you will be used to make such determination. Please check with your system administrator if you need access to certain types of sensitive, 
confidential, or regulated data.  
  
  `
  
export default content;
